<template>
  <v-page-content>
    <b-card class="students-card" responsive>
      <div class="d-flex flex-wrap mb-2">
        <h4>
          <em class="fas fa-users"></em> <span class="ml-2">Список учеников</span>
        </h4>
        <div class="d-inline-flex flex-wrap justify-content-end ml-auto">
          <b-dropdown
            v-if="hasRole(roles_.admin) || hasRole(roles_.curator)"
            variant="outline-primary"
            class="addButton topSection align-items-center mr-1 mb-1"
          >
            <template #button-content>
              <em class="fas fa-file-excel mr-1"></em> Экспорт
            </template>
            <b-dropdown-item
              href="/api/admins/students/xlsx"
              target="_blank">
              <span class="text-primary">Всех учеников</span>
            </b-dropdown-item>
            <b-dropdown-item
              href="/api/admins/students/xlsx?active=true"
              target="_blank">
              <span class="text-success">Только активных</span>
            </b-dropdown-item>
            <b-dropdown-item
              href="/api/admins/students/xlsx?active=false"
              target="_blank">
              <span class="text-grey">Только неактивных</span>
            </b-dropdown-item>
          </b-dropdown>
          <b-btn v-if="isShowsUntranslated"
                 variant="outline-primary"
                 class="addButton topSection align-items-center mr-1 mb-1"
                 @click="onUntranslatedShowChanged"
                 :disabled="!isShowsActive"
          >
            <em class="far fa-eye-slash mr-1"></em> Показать переведенных
          </b-btn>
          <b-btn v-else-if="!isShowsUntranslated"
                 variant="outline-primary"
                 class="addButton topSection align-items-center mr-1 mb-1"
                 @click="onUntranslatedShowChanged"
          >
            <em class="far fa-eye mr-1"></em> Скрыть переведенных
          </b-btn>
          <b-btn v-if="isShowsActive"
                 variant="outline-primary"
                 class="addButton topSection align-items-center mb-1"
                 @click="onActiveShowChanged"
                 :disabled="!isShowsUntranslated"
          >
            <em class="far fa-eye-slash mr-1"></em> Показать неактивных
          </b-btn>
          <b-btn v-else
                 variant="outline-primary"
                 class="addButton topSection align-items-center mb-1"
                 @click="onActiveShowChanged"
          >
            <em class="far fa-eye mr-1"></em> Показать активных
          </b-btn>
        </div>
      </div>
      <div>
        <b-form-select v-if="!isLoading"
                       v-model="selectedOrg" :options="optionsOrg"
                       v-b-tooltip.hover title="Организация" id="orgSelectForStudents"
                       @input="orgChanged" class="mt-2"></b-form-select>
        <b-form-select v-if="!isLoading"
                       v-model="selectedClass" :options="optionsClass"
                       v-b-tooltip.hover title="Класс" id="classSelectForStudents"
                       @input="classChanged" class="mt-2"
                       :disabled="!isShowsUntranslated"
        ></b-form-select>
      </div>
      <div class="ag-grid-vue-studentsList mt-2" ref="gridDiv">
        <ag-grid-vue
          style="width: 100%; height: 100%;"
          class="ag-theme-material"
          id="grid"
          rowSelection="multiple"
          rowHeight="78"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          @filterChanged="onFilterChanged"
          @grid-ready="onGridReady"
          @gridSizeChanged="onGridSizeChanged"
          @rowSelected="updateSelectedStudent"
          :pagination="true"
          :paginationPageSize="20"
          :currentPage="1"
          :frameworkComponents="frameworkComponents"
          :context=context
        >
        </ag-grid-vue>
      </div>
      <b-row class="pagination-row mt-2 pr-2">
        <div class="d-inline-flex flex-wrap justify-content-end addButtons">
          <b-btn
           variant="primary"
           class="addButton bottomSection align-items-center mr-1 mb-1"
           v-b-modal.studentsAddModal
           :disabled="!isCorrectOrg"
          >
            <em class="fas fa-user-plus mr-1"></em> Добавить учеников
          </b-btn>
          <b-btn
           variant="primary"
           class="addButton bottomSection align-items-center mr-1 mb-1"
           @click="removeStudentsFromClass"
           v-b-modal.studentsRemoveModal
           :disabled="storageLength < 1 || !isShowsActive || !isCorrectOrg"
          >
            <span v-if="storageLength < 1"
                  v-b-tooltip.mouseover
                  title="Выберите одного или нескольких учеников"
            >
              <em class="fas fa-user-minus mr-1"></em> Удалить учеников
            </span>
            <span v-else>
              <em class="fas fa-user-minus mr-1"></em> Удалить учеников
            </span>
          </b-btn>
          <b-btn v-if="hasRole(roles_.admin) || hasRole(roles_.curator)"
                 variant="primary"
                 class="addButton bottomSection align-items-center mr-1 mb-1"
                 @click="exportPortfolio"
                 :disabled="storageLength < 1 || !isShowsActive"
          >
            <span v-if="storageLength < 1"
                  v-b-tooltip.mouseover
                  title="Выберите одного или нескольких учеников"
            >
              <em class="fas fa-file-excel mr-1"></em> Экспортировать портфолио
            </span>
            <span v-else>
              <em class="fas fa-file-excel mr-1"></em> Экспортировать портфолио
            </span>
          </b-btn>
          <b-btn
            v-if="isShowsUntranslated"
            variant="primary"
            class="addButton bottomSection align-items-center mr-1 mb-1"
            @click="translateStudentsToNextStage"
            v-b-modal.studentsTranslateModal
            :disabled="storageLength < 1 || !isShowsActive || !isCorrectOrg"
          >
            <span v-if="storageLength < 1"
                  v-b-tooltip.mouseover
                  title="Выберите одного или нескольких учеников"
            >
              <em class="fas fa-level-up-alt mr-1"></em> Перевести
            </span>
            <span v-else>
              <em class="fas fa-level-up-alt mr-1"></em> Перевести
            </span>
          </b-btn>
          <b-btn
            v-if="!isShowsUntranslated"
            variant="primary"
            class="addButton bottomSection align-items-center mr-1 mb-1"
            @click="undoTranslateStudentsToNextStage"
            v-b-modal.studentsUndoTranslateModal
            :disabled="storageLength < 1 || !isShowsActive || !isCorrectOrg"
          >
            <span v-if="storageLength < 1"
                  v-b-tooltip.mouseover
                  title="Выберите одного или нескольких учеников"
            >
              <em class="fas fa-level-down-alt mr-1"></em> Отменить перевод
            </span>
            <span v-else>
              <em class="fas fa-level-down-alt mr-1"></em> Отменить перевод
            </span>
          </b-btn>
        </div>
      </b-row>
    </b-card>
    <students-add-modal
      :selected-org="selectedOrg"
    />
    <students-remove-modal
      :chosen-students="studentsForActions"
      @studentsRemoved="onRemoveConfirm" />
    <students-translate-modal
      :chosen-students="studentsForActions"
      @studentsTranslated="onTranslateConfirm"/>
    <students-undo-translate-modal
      :chosen-students="studentsForActions"
      @studentsTranslatedBack="onUndoTranslateConfirm"/>
    <confirm-delete-modal
      :name="studentForDel.name"
      :surname="studentForDel.surname"
      :midname="studentForDel.midname"
      :id="studentForDel.id"
      @userDeleted="onDeleteConfirm"/>
    <release-student-modal
      :name="studentForDel.name"
      :surname="studentForDel.surname"
      :midname="studentForDel.midname"
      :id="studentForDel.id"
      @studentReleased="onReleaseConfirm"/>
  </v-page-content>
</template>
<script>
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import { mapActions, mapGetters } from 'vuex'
import AvatarRenderer from '@/components/helpers/renderers/AvatarRenderer'
import ActionDeleteStudent from '@/components/students/actions/ActionDeleteStudent'
import ActionReleaseStudent from '@/components/students/actions/ActionReleaseStudent'
import PartialMatchFilter from '@/components/helpers/filters/PartialMatchFilter'
import ResetFiltersHeader from '@/components/helpers/headers/ResetFiltersHeader'
import invitationApi from '@/api/invitation'
import portfolioApi from '@/api/portfolio'
import organizationApi from '@/api/organization'
import usersApi from '@/api/users'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import { roles } from '@/config/roles'

const StudentsAddModal = () => import('@/components/students/modals/StudentsAddModal.vue')
const StudentsRemoveModal = () => import('@/components/students/modals/StudentsRemoveModal.vue')
const StudentsTranslateModal = () => import('@/components/students/modals/StudentsTranslateModal.vue')
const StudentsUndoTranslateModal = () => import('@/components/students/modals/StudentsUndoTranslateModal.vue')
const ConfirmDeleteModal = () => import('@/components/admin/modals/users/ConfirmDeleteModal.vue')
const ReleaseStudentModal = () => import('@/components/students/modals/ConfirmReleaseStudentModal.vue')

export default {
  name: 'StudentList',
  components: {
    'ag-grid-vue': AgGridVue,
    StudentsAddModal,
    StudentsRemoveModal,
    StudentsTranslateModal,
    StudentsUndoTranslateModal,
    ConfirmDeleteModal,
    ReleaseStudentModal
  },
  data() {
    return {
      roles_: roles,
      isFilterLoading: false,
      selectedOrg: null,
      selectedClass: ['10', '11'],
      optionsClass: [
        { value: ['10', '11'], text: 'Все' },
        { value: ['10'], text: '10' },
        { value: ['11'], text: '11' }
      ],
      studentForDel: {
        id: null,
        name: '',
        surname: '',
        midname: ''
      },
      columnDefs: null,
      rowData: null,
      gridApi: null,
      columnApi: null,
      isShowsActive: true,
      isShowsUntranslated: true,
      gridOptions: {
        defaultColDef: {
          headerName: '',
          autoHeight: false,
          sortable: true,
          filter: 'partialMatchFilter',
          headerClass: 'students-table-header',
          cellStyle: {
            'word-break': 'break-all'
          }
        },
        localeText: AG_GRID_LOCALE_RU,
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true,
        deltaColumnMode: true
      },
      frameworkComponents: {
        partialMatchFilter: PartialMatchFilter,
        avatarRenderer: AvatarRenderer,
        actionDeleteStudent: ActionDeleteStudent,
        actionReleaseStudent: ActionReleaseStudent,
        resetFiltersHeader: ResetFiltersHeader
      },
      context: {
        componentParent: this
      },
      rowGroupPanelShow: null,
      pivotPanelShow: null,
      selected: [],
      storageLength: 0,
      selectedStudents: [],
      studentsForActions: [],
      studentsForRemove: [],
      organizations: [],
      isLoading: true
    }
  },
  created() {
    organizationApi.getClasses().then(({ data }) => {
      this.organizations = Object.values(data)
      let storedOrg = null
      let storedClass = null
      if (this.hasRole('admin') || this.hasRole('curator')) {
        storedOrg = localStorage.getItem('studentsListOrg')
        storedClass = localStorage.getItem('studentsListClass')
      }
      this.selectedOrg = Number(storedOrg) || this.optionsOrg[0].value
      this.selectedClass = storedClass ? storedClass.split(',') : this.optionsClass[0].value
      this.debouncedFetch(this.getFilteredUsers(), this.getSorting())
      this.resetFilters()
      this.isLoading = false
      const org = this.organizations.find((o) => o.id === this.currUser.organizationId)
      if (this.hasRole('classroom-teacher') && org) {
        this.selectedOrg = org.id
      }
      this.columnDefs = this.getColumnDefs()
      sessionStorage.clear()
      this.storageLength = 0
      usersApi.getStudents({
        filters: [{
          param: 'active',
          needle: this.isShowsActive,
          isStrict: false
        },
        {
          param: 'roles',
          needle: ['student'],
          isStrict: false
        },
        {
          param: 'movingToNextClassDate',
          needle: this.isShowsUntranslated,
          start: new Date(),
          end: new Date(+new Date() + (24 * 60 * 60 * 1000))
        },
        {
          param: 'organizationId',
          needle: [this.selectedOrg]
        },
        {
          param: 'class',
          class: this.selectedClass,
          needle: this.isShowsUntranslated
        }],
        sorting: ''
      }).then(({ _data }) => {
        this.rowData = _data.students
        this.gridOptions.api.setRowData(this.rowData)
      }).catch((error) => {
        console.log(error)
      })
      this.debouncedFetchFilteredData = _.debounce((filters, sorting) => {
        this.debouncedFetch(filters, sorting)
      }, 500)
      this.debouncedFetchSortedData = _.debounce((filters, sorting) => {
        this.debouncedFetch(filters, sorting)
      }, 0)
    })
  },
  beforeDestroy() {
    sessionStorage.clear()
  },
  computed: {
    ...mapGetters({
      hasRole: 'currentUser/hasRole',
      currUser: 'currentUser/getCurrentUser'
    }),
    isCorrectOrg() {
      return this.selectedOrg === this.currUser.organizationId || this.hasRole('curator') || this.hasRole('admin')
    },
    optionsOrg() {
      if (this.organizations && this.organizations.length) {
        const organizations = this.organizations.filter((p) => p.type === 'ГП-класс')
        if (this.hasRole(this.roles_.curator) || this.hasRole(this.roles_.admin)) {
          return organizations.map((org) => {
            const cityStr = (org.city && !!org.city.trim()) ? `${org.city}, ` : ''
            return {
              value: org.id,
              text: cityStr + org.title
            }
          }).sort((org1, org2) => (org1.text > org2.text ? 1 : -1))
        } if (this.hasRole(this.roles_.teacher)) {
          return [{
            value: this.currUser.organizationId,
            text: organizations.find((p) => p.id === this.currUser.organizationId).title
          }]
        }
      }
      return []
    }
  },
  methods: {
    stringComparator(first, second) {
      return first.toLowerCase().localeCompare(second.toLowerCase())
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      if (this.$refs.gridDiv.clientWidth >= 1300) {
        this.gridApi.sizeColumnsToFit()
      }
    },
    onGridSizeChanged() {
      if (this.$refs.gridDiv.clientWidth >= 700) {
        this.gridApi.sizeColumnsToFit()
      }
    },
    onDeleteConfirm() {
      this.debouncedFetchFilteredData(this.getFilteredUsers(), this.getSorting())
    },
    onTranslateConfirm() {
      this.translateStudents(this.selectedStudents).then((res) => {
        if (res.data && res.data.message) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Во время перевода учеников произошла ошибка. Ученики не были переведены.'
          })
        } else {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Ученики успешно переведены. У Вас есть 24 часа на отмену перевода.'
          })
          this.debouncedFetch(this.getFilteredUsers(), this.getSorting())
        }
      })
    },
    onUndoTranslateConfirm() {
      this.undoTranslateStudents(this.selectedStudents).then((res) => {
        if (res.data && res.data.message) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Во время отмены перевода учеников произошла ошибка. Перевод учеников не был отменен.'
          })
        } else {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Перевод успешно отменен.'
          })
          this.debouncedFetch(this.getFilteredUsers(), this.getSorting())
        }
      })
    },
    onRemoveConfirm() {
      this.removeStudents(this.selectedStudents).then((res) => {
        if (res.data && res.data.message) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Во время удаления учеников произошла ошибка. Учеников не были удалены.'
          })
          this.debouncedFetch(this.getFilteredUsers(), this.getSorting())
        } else {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Удаление успешно выполнено.'
          })
          this.debouncedFetch(this.getFilteredUsers(), this.getSorting())
        }
      })
    },
    onReleaseConfirm() {
      this.releaseStudent(this.studentForDel.id).then((res) => {
        if (res.data && res.data.message) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Во время выпуска ученика произошла ошибка. Ученик не был выпущен.'
          })
        } else {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Ученик успешно выпущен.'
          })
          this.debouncedFetch(this.getFilteredUsers(), this.getSorting())
        }
      })
    },
    onParentReleaseClicked(data) {
      this.resetModalInfo()
      this.studentForDel.name = data.name
      this.studentForDel.surname = data.surname
      this.studentForDel.midname = data.midname
      this.studentForDel.id = data.id
      this.$bvModal.show('confirmReleaseStudentModal')
    },
    onParentDeleteClicked(data) {
      this.resetModalInfo()
      this.studentForDel.name = data.name
      this.studentForDel.surname = data.surname
      this.studentForDel.midname = data.midname
      this.studentForDel.id = data.id
      this.$bvModal.show('confirmDeleteModal')
    },
    async onParentReinviteClicked(data) {
      await invitationApi.sendInvitationsStudents({
        users: [data],
        organizationId: data.organizationId,
        class: data.studentProfile.class
      })
      this.pushToasts({
        title: 'Уведомление',
        message: `Отправлено повторное приглашение на ${data.email}`
      })
    },
    resetModalInfo() {
      this.studentForDel.id = null
      this.studentForDel.name = ''
      this.studentForDel.surname = ''
      this.studentForDel.midname = ''
    },
    getFilteredUsers() {
      const filters = this.gridOptions.api
        ? this.gridOptions.api.getFilterModel()
        : {}
      const params = []
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(filters)) {
        if (value.value) {
          const param = {}
          param.param = key
          param.needle = value.value
          param.isStrict = false
          params.push(param)
        }
      }
      params.push(
        {
          param: 'active',
          needle: this.isShowsActive,
          isStrict: false
        },
        {
          param: 'movingToNextClassDate',
          needle: this.isShowsUntranslated,
          start: new Date(),
          end: new Date(+new Date() + (24 * 60 * 60 * 1000))
        },
        {
          param: 'roles',
          needle: ['student'],
          isStrict: false
        },
        {
          param: 'organizationId',
          needle: [this.selectedOrg]
        },
        {
          param: 'class',
          class: this.selectedClass,
          needle: this.isShowsUntranslated
        },
      )
      return params
    },
    getSorting() {
      const sorting = this.gridOptions.api.getSortModel()
      const sortingQuery = []
      sorting.forEach((el) => {
        const param = []
        if (el.colId === 'class') {
          param[0] = 'studentProfile'
          param[1] = 'class'
          param[2] = el.sort.toUpperCase()
        } else if (el.colId === 'roles') {
          param[0] = 'roles'
          param[1] = 'title'
          param[2] = el.sort.toUpperCase()
        } else if (el.colId === 'organization') {
          param[0] = 'organization'
          param[1] = 'title'
          param[2] = el.sort.toUpperCase()
        } else {
          param[0] = el.colId
          param[1] = el.sort.toUpperCase()
        }
        sortingQuery.push(param)
      })
      return sortingQuery
    },
    async onActiveShowChanged() {
      this.isFilterLoading = true
      this.isShowsActive = !this.isShowsActive
      this.resetFilters()
      await this.debouncedFetch(this.getFilteredUsers(), this.getSorting())
      this.isFilterLoading = false
    },
    classFormatter(params) {
      if (params.data.studentProfile) {
        return params.data.studentProfile.class
      }
      return null
    },
    async onUntranslatedShowChanged() {
      this.isFilterLoading = true
      this.isShowsUntranslated = !this.isShowsUntranslated
      this.selectedClass = ['10', '11']
      this.resetFilters()
      await this.debouncedFetch(this.getFilteredUsers(), this.getSorting())
      this.isFilterLoading = false
    },
    onFilterChanged() {
      this.debouncedFetchFilteredData(this.getFilteredUsers(), this.getSorting())
    },
    onSortChanged() {
      this.debouncedFetchSortedData(this.getFilteredUsers(), this.getSorting())
    },
    async debouncedFetch(filters, sorting) {
      sessionStorage.clear()
      this.storageLength = 0
      const payload = { filters: '', sorting: '' }
      if (filters) payload.filters = filters
      if (sorting) payload.sorting = sorting
      await usersApi.getStudents(payload).then(({ data }) => {
        this.rowData = data.students
        this.gridOptions.api.setRowData(this.rowData)
      })
      setTimeout(() => {
        this.gridApi.sizeColumnsToFit()
      }, 0)
    },
    resetFilters() {
      this.gridOptions.api.setFilterModel(null)
      this.gridOptions.api.setSortModel(null)
    },
    reloadList() {
      this.columnDefs = this.getColumnDefs()
      this.debouncedFetch(this.getFilteredUsers(), this.getSorting())
      this.resetFilters()
    },
    orgChanged(evt) {
      if (this.hasRole(this.roles_.admin) || this.hasRole(this.roles_.curator)) {
        localStorage.setItem('studentsListOrg', evt)
      }
      this.reloadList()
    },
    classChanged(evt) {
      if (this.hasRole(this.roles_.admin) || this.hasRole(this.roles_.curator)) {
        localStorage.setItem('studentsListClass', evt)
      }
      this.reloadList()
    },
    updateNodesSelection() {
      if (this.gridApi) {
        this.gridApi.forEachNode((node) => {
          node.setSelected(sessionStorage.getItem(node.data.id) === 'true')
        })
      }
    },
    updateSelectedStudent(params) {
      sessionStorage.setItem(params.node.data.id, params.node.selected)
      const keys = Object.keys(sessionStorage)
      this.storageLength = keys.filter((el) => (sessionStorage.getItem(el) === 'true')).length
    },
    exportPortfolio() {
      const keys = Object.keys(sessionStorage)
      this.selectedStudents = keys.filter((el) => (sessionStorage.getItem(el) === 'true'))
      portfolioApi.portfolioExportRequest(this.selectedStudents)
    },
    translateStudentsToNextStage() {
      const keys = Object.keys(sessionStorage)
      this.selectedStudents = keys.filter((el) => (sessionStorage.getItem(el) === 'true'))
      this.studentsForActions = []
      // eslint-disable-next-line array-callback-return
      this.studentsForActions = this.rowData.filter(
        (stud) => this.selectedStudents.includes(String(stud.id)),
      )
        .map((student) => ({
          id: student.id,
          email: student.email,
          surname: student.surname,
          name: student.name,
          midname: student.midname,
          from: student.studentProfile.class,
          to: student.studentProfile.class === '10' ? '11' : 'выпуск'
        }))
      this.$bvModal.show('studentsTranslateModal')
    },
    undoTranslateStudentsToNextStage() {
      const keys = Object.keys(sessionStorage)
      this.selectedStudents = keys.filter((el) => (sessionStorage.getItem(el) === 'true'))
      this.studentsForActions = []
      // eslint-disable-next-line array-callback-return
      this.studentsForActions = this.rowData.filter(
        (stud) => this.selectedStudents.includes(String(stud.id)),
      )
        .map((student) => ({
          id: student.id,
          email: student.email,
          surname: student.surname,
          name: student.name,
          midname: student.midname,
          from: student.studentProfile.class,
          to: student.studentProfile.class === 'выпускник' ? '11' : '10'
        }))
      this.$bvModal.show('studentsUndoTranslateModal')
    },
    removeStudentsFromClass() {
      const keys = Object.keys(sessionStorage)
      this.selectedStudents = keys.filter((el) => (sessionStorage.getItem(el) === 'true'))
      this.studentsForActions = []
      // eslint-disable-next-line array-callback-return
      this.studentsForActions = this.rowData.filter(
        (stud) => this.selectedStudents.includes(String(stud.id)),
      )
        .map((student) => ({
          id: student.id,
          email: student.email,
          surname: student.surname,
          name: student.name,
          midname: student.midname
        }))
      this.$bvModal.show('studentsRemoveModal')
    },
    getColumnDefs() {
      if ((this.selectedOrg === this.currUser.organizationId && this.hasRole('classroom-teacher')) || this.hasRole(this.roles_.admin)) {
        let option = [
          {
            field: 'avatarFile',
            suppressSizeToFit: true,
            cellRenderer: 'avatarRenderer',
            colId: 'avatar',
            width: 150,
            cellStyle: null,
            sortable: false,
            filter: null,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true
          },
          {
            headerName: 'Рег. номер',
            field: 'id',
            colId: 'id',
            width: 200,
            suppressSizeToFit: true
          },
          {
            headerName: 'E-mail',
            field: 'email',
            suppressSizeToFit: true,
            colId: 'email',
            width: 240,
            minWidth: 150,
            comparator: this.stringComparator
          },
          {
            headerName: 'Фамилия',
            field: 'surname',
            width: 150,
            minWidth: 150
          },
          {
            headerName: 'Имя',
            field: 'name',
            width: 150,
            minWidth: 150
          },
          {
            headerName: 'Отчество',
            field: 'midname',
            width: 150,
            minWidth: 150
          },
          {
            headerName: 'Класс',
            field: 'class',
            sortable: false,
            filter: false,
            headerClass: 'students-table-header',
            cellStyle: {
              'word-break': 'break-all'
            },
            width: 100,
            suppressSizeToFit: true,
            valueFormatter: this.classFormatter
          }
        ]
        if (!this.hasRole(this.roles_.admin)) {
          option = _.filter(option, (d) => d.headerName !== 'Рег. номер')
        }
        return option
      }
      return [
        {
          headerName: 'Рег. номер',
          field: 'id',
          colId: 'id',
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          suppressSizeToFit: true
        },
        {
          headerName: 'E-mail',
          field: 'email',
          colId: 'email',
          comparator: this.stringComparator
        },
        {
          headerName: 'Класс',
          field: 'class',
          sortable: false,
          filter: false,
          headerClass: 'students-table-header',
          cellStyle: {
            'word-break': 'break-all'
          },
          valueFormatter: this.classFormatter,
          suppressSizeToFit: true
        }
      ]
    },
    ...mapActions({
      pushToasts: 'toasts/pushToasts',
      releaseStudent: 'user/releaseStudent',
      translateStudents: 'users/translateStudents',
      undoTranslateStudents: 'users/undoTranslateStudents',
      removeStudents: 'users/removeStudents'
    })
  }
}
</script>

<style lang="scss">
@import "../../sass/vendor/bootstrap/variables";

.students-card {
  padding-bottom: 0;
}

.students-card .addButtons {
  width: 100%;
}

.students-card .icon {
  margin-right: 6px;
  font-size: 1.333333em;
}
.students-card .addButton.topSection {
  width: 235px;
}
@media screen and (max-width: 495px){
  .students-card .addButton.bottomSection {
    width: 100%;
  }
}

.students-card .ag-header-cell-label {
  justify-content: left;
}

.students-card .ag-row .ag-cell {
  display: inline-flex;
  align-items: center;
  font-size: 15px;
  justify-content: left;
  text-align: left;
  white-space: normal;
  line-height: 1.4em !important;
}

.students-card .ag-grid-table-header {
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: left;
  color: #000;
  font-weight: bold;
}

.students-card .ag-grid-vue-students.ag-row .ag-cell {
  display: flex;
  align-items: center;
  font-size: 15px;
  justify-content: left;
  text-align: left;
  white-space: normal;
  line-height: 1.4em;
}

.students-card .students-table-header {
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: left;
  color: #000;
  font-weight: bold;
}

.students-card .role-box {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align: left;
  align-items: center;
  justify-content: left;
}

.students-card .ag-cell {
  padding-left: 24px !important;
}

.students-card .ag-cell img {
  padding-left: 0;
}

.students-card .role-badge {
  font-size: 10px;
  width: 100px;
}

.students-card .role-badge:nth-child(n+1) {
  margin-right: 5px;
}

.students-card .ag-grid-vue-students.ag-cell-focus, .ag-grid-vue-students.ag-cell-no-focus {
  border: none !important;
}

.students-card .ag-grid-vue-students.ag-cell:focus {
  border: none !important;
  outline: none;
}

.students-card .ag-grid-vue-studentsList {
  height: calc(100vh - 332px);
  border-bottom: 1px solid lightgray;
}

.students-card .ag-grid-vue-studentsList .resetFiltersHeader-btn {
  width: 60px !important;
  height: 30px;
}

.students-card .clear-icon {
  color: rgb(230, 99, 99);
  position: relative;
  right: 10px;
}

.students-card .filter-input {
  width: 100%;
  border: none;
  margin: 0;
}

.students-card .filter-container {
  border: 1px lightgray solid;
  padding: 0 0 5px 5px;
}

.students-card .space {
  margin-right: 5px;
}

.students-card .select {
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  font-size: 1rem;
  border-radius: 0.25rem;
  line-height: 1.5;
  font-weight: 400;
}
.students-card #orgSelectForStudents {
  width: 80%;
  margin-right: 2%;
}
.students-card #classSelectForStudents {
  width: 18%;
  min-width: 72px;
}

.students-card .usersList__paginator {
  position: relative !important;
  text-align: right !important;
}

</style>
